import { RGBColor } from 'react-color';

import { isArrayEmpty } from 'util/isArrayEmpty';

import tinycolor from 'tinycolor2';

export type ClientDto = {
  id: number;
  circleId?: string;
  name: string;
  logo: string;
  brandColor: string;
  timezone: string;
  approxEmployeeNumber: number;
  sectors: number[];
  plan: number;
  pulse_templates: {
    id: number;
    reportDashboardUrl: string;
  }[];
};

export type ClientModel = {
  id?: number;
  circleId: string;
  plan: number;
  name: string;
  logo?: string;
  brandColor?: RGBColor;
  timezone: string;
  approxEmployeeNumber?: number;
  sectors?: number[];
  pulseTemplates?: number[];
  url: string;
};

export function mapClientModelToDto(model: ClientModel): ClientDto {
  return {
    id: model.id,
    circleId: model.circleId,
    name: model.name,
    logo: model.logo,
    brandColor: tinycolor(model.brandColor).toHexString(),
    timezone: model.timezone,
    approxEmployeeNumber: model.approxEmployeeNumber,
    sectors: model.sectors,
    plan: model.plan,
    pulse_templates:
      model.pulseTemplates &&
      model.pulseTemplates.map((id) => ({
        id,
        reportDashboardUrl: model.url,
      })),
  };
}

export function mapClientDtoToModel(dto: ClientDto): ClientModel {
  return {
    id: dto.id,
    circleId: dto.circleId,
    name: dto.name,
    logo: dto.logo,
    sectors: dto.sectors,
    approxEmployeeNumber: dto.approxEmployeeNumber,
    timezone: dto.timezone,
    plan: dto.plan,
    // Fields that differ from Api Entry
    brandColor: tinycolor(dto.brandColor).toRgb(),
    pulseTemplates: dto.pulse_templates.map(({ id }) => id),
    url: dto.pulse_templates.length ? dto.pulse_templates[0].reportDashboardUrl : undefined,
  };
}

export namespace Client {
  export function getFirstPulseTemplateId(client: ClientModel): number {
    return !isArrayEmpty(client.pulseTemplates) ? client.pulseTemplates?.[0] : null;
  }
}
